<template>
  <div class="flex justify-center">
    <img :src="merchantLogo ? merchantLogo : DefaultImage" class="layup-logo size-32 h-auto" />
  </div>
</template>

<script lang="ts" setup>
import DefaultImage from '@/assets/logo.svg';
import { useWidgetStore } from '@/stores/widget';
import { computed } from 'vue';

const props = defineProps<{
  type?: 'boost' | 'payment-plan';
}>();

const widgetStore = useWidgetStore();
const merchantLogo = computed(() => {
  if (props.type === 'boost') {
    if (widgetStore.boost?.merchant?.customFeatures?.paymentWidget?.enabled)
      return widgetStore.boost.merchant.customFeatures?.paymentWidget?.value;
  } else if (widgetStore.paymentPlanPreview?.customFeatures?.paymentWidget?.enabled) {
    return widgetStore.paymentPlanPreview.customFeatures.paymentWidget.value;
  }

  return null;
});
</script>
